import { withRouter } from 'react-router';
import PayAndConfirmMutation from './PayAndConfirmMutation';

export default withRouter(PayAndConfirmMutation);
